import {
  MemberWorkloadStatusRow,
  MemberWorkloadStatusType,
} from '../MemberWorkloadStatus'

export const isEstimatedActualOfRow = (
  nodeData: MemberWorkloadStatusRow,
  baseRow: MemberWorkloadStatusRow,
  getRowGroupColumnKey: (row: MemberWorkloadStatusRow) => string | undefined
): boolean => {
  if (!nodeData || !baseRow) return false
  const uuid = getRowGroupColumnKey(baseRow)
  if (!uuid) return false
  return (
    getRowGroupColumnKey(nodeData) === uuid &&
    nodeData.type === MemberWorkloadStatusType.ESTIMATED_ACTUAL &&
    nodeData.estimatedActualType === baseRow.estimatedActualType
  )
}
